import Vue from 'vue'
import Vuex from 'vuex'
import {API} from 'aws-amplify'
import {Auth} from 'aws-amplify'

Vue.use(Vuex)

var ReportDataList = new Vuex.Store({
    state: {
        dailyData: {},
        realtimeData: [],
        configurationData: {},
        previousData: {
            // 過去データ取得フラグ
            isPrevious: "False",
            // 検索条件
            terms: {
                startDate: '',
                endDate: ''
            },
            // response結果
            dataset: {},
        }
    },
    mutations: {
        initialize (state){
            state.dailyData = {}
            state.realtimeData = []
            state.thresholdsData = {}
            state.previousData = {
                // 過去データ取得フラグ
                isPrevious: "",
                terms: {
                    startDate: '',
                    endDate: ''
                },
                // response結果
                dataset: {},
                actionFlg: false
            }
        }, 
        currentIdToken (state, payload){
            state.idToken = payload
        },
        getRealtimeData (state, payload) {
            state.realtimeData = JSON.parse(payload)
        },
        getReportData (state, payload) {
            let temp = JSON.parse(payload)
            temp.dataset.sort(function(a, b) {
              if (a.stream_id > b.stream_id) {
                return 1;
              } else {
                return -1;
              }
            })
            state.dailyData = temp
        },
        getPreviousData (state, payload) {
            state.previousData.dataset = JSON.parse(payload)
        }
    },
    actions: {
        async initialize(context){
            context.commit('initialize')
        },
        
        async setCurrentSessionIdToken (context, {idToken}) {
            context.commit('currentIdToken', idToken)
        },

        async getRealtimeData (context) {
            let cognitoUser = await Auth.currentAuthenticatedUser()
            const jwtToken = cognitoUser.signInUserSession.idToken.jwtToken
            const headers = {
                            "Content-type" : "application/json", 
                            'Authorization': jwtToken
                          }
            const apiName = 'peopleCountAPI';
            const path = '/realtime-count';
            const myInit = {headers: headers};

            return await API.get(apiName, path, myInit)
                .then(response => {
                    context.commit('getRealtimeData', response['body'])
                })
                .catch(error => {
                    console.error(error.response.data.errorMessage)
                    if(error.response.status == 401){
                        throw new Error("最新データ：APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("最新データ：サーバの問題で取得に失敗しました。")
                    } else {
                        throw new Error("最新データ：データの取得に失敗しました。")
                    }
                });

        },
        //レポートのテーブル・グラフデータ
        async getReportData (context) {
            let cognitoUser = await Auth.currentAuthenticatedUser()
            const jwtToken = cognitoUser.signInUserSession.idToken.jwtToken
            const headers = {
                            "Content-type" : "application/json", 
                            'Authorization': jwtToken
                          }
            const apiName = 'peopleCountAPI';
            const path = '/maxmin-count';
            const myInit = {headers: headers,
                            "queryStringParameters": {
                                isPrevious: "False"
                            }
            };
            return await API
                .get(apiName, path, myInit)
                .then(response => {
                    context.commit('getReportData', response['body'])
                })
                .catch(error => {
                    console.error(error.response.data.errorMessage)
                    if(error.response.status == 401){
                        throw new Error("レポートデータ：APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("レポートデータ：サーバの問題で取得に失敗しました。")
                    } else {
                        throw new Error("レポートデータ：データの取得に失敗しました。")
                    }
                });
        },
        // 設定画面更新
        async updateOption (context) {
            let cognitoUser = await Auth.currentAuthenticatedUser()
            const jwtToken = cognitoUser.signInUserSession.idToken.jwtToken
            const headers = {
                            "Content-Type" : "application/json",
                            "Authorization": jwtToken
                        }
            const query = JSON.stringify(context.state.configurationData)
            const apiName = 'peopleCountAPI';
            const path = '/stream-info';
            const myInit = {
                            headers: headers,
                            body: {
                                configurationData: query
                            }
                            
                        };
            return await API
                .put(apiName, path, myInit)
                .then(
                    setTimeout(function() {
                        context.dispatch('getReportData')
                        context.dispatch('getRealtimeData')
                    }, 800)
                )
                .catch(error => {
                    console.error(error.response.data.errorMessage)
                    if(error.response.status == 401){
                        throw new Error("設定：APIの認証に失敗しました。")
                    }else if (error.response.status === 500) {
                        throw new Error("設定：サーバーの問題で更新に失敗しました。")
                    } else {
                        throw new Error("設定：データの更新に失敗しました。")
                    }
                });
        },
        // 過去データ取得
        async getPreviousData (context) {
            let cognitoUser = await Auth.currentAuthenticatedUser()
            const jwtToken = cognitoUser.signInUserSession.idToken.jwtToken
            const headers = {
                            "Content-type" : "application/json",
                            'Authorization': jwtToken
                          }
            const apiName = 'peopleCountAPI';
            const query = JSON.stringify(context.state.previousData.terms)
            const path = '/maxmin-count';
            const myInit = {
                            headers: headers,
                            queryStringParameters: {
                                isPrevious: "True",
                                terms: query
                            }
                        };
            return await API
                .get(apiName, path, myInit)
                .then(response => {
                    context.commit('getPreviousData', response['body'])
                })
                .catch(error => {
                    console.error(error.response.data.errorMessage)
                    if(error.response.status == 401){
                        throw new Error("過去データ：APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("過去データ：サーバの問題で取得に失敗しました")
                    } else {
                        throw new Error("過去データ：データの取得に失敗しました")
                    }
                });
        }
    },
    getters: {
        // 設定画面による更新処理完了確認フラグ
        isCompleteUpdate: state => {
            let isComplete = true
            // オブジェクト生成前に確認処理実行によるエラー回避
            if (Object.keys(state.dailyData).length && Object.keys(state.configurationData).length) {
                state.dailyData.dataset.some(stream => {
                    const confObj = state.configurationData[stream.stream_id]
                    let mailFlag = 0
                    if (confObj.sendMailFlag === "true") {
                        mailFlag = 1
                    }
                    if (stream.threshold !== confObj.thresholdNumber || 
                        stream.sendMailFlag !== mailFlag || 
                        stream.excessCountLimit !== confObj.exccessCountLimit) {
                        
                        isComplete = false
                    }
                });
            }
            return isComplete
        }
    }
    
})

export default ReportDataList